function ConfirmationPopup({ message, isError }) {
  return (
    <div className="popup">
      <div className="popup-card">
        <h2>{isError ? "Error" : "Order Submitted"}</h2>
        <p>
          {message ||
            "Thank you! Your jacket order has been received."}
        </p>
      </div>
    </div>
  );
}

export default ConfirmationPopup;